import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  TablePagination,
  TextField,
  Tooltip,
  Button,
  IconButton,
  Drawer,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Popover,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControlLabel,
  Checkbox,
  DialogActions,
} from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import Avatar from "@mui/material/Avatar";
import { FILE_RULES, validateFile } from "../../utils/fileValidation";
import Chip from "@mui/material/Chip";
import RefreshIcon from "@mui/icons-material/Refresh";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { BASE_URL, TARGET_TYPE } from "../../constants";
import AddIcon from "@mui/icons-material/Add";
import { useRecoilValue } from "recoil";
import { authState } from "../../recoil/authAtom";
import Log from "../logDialog/Log";
import excelIcon from "../../images/excel-icon.png";
import pdfIcon from "../../images/pdf-icon.png";
import { toast } from "react-toastify";
import AppointmentPdfSettings from "./AppointmentPdfSettings";
import PdfLayoutGuide from "./PdfLayoutGuide";
const DoctorList = () => {
  const user = useRecoilValue(authState);
  const [searchQuery, setSearchQuery] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [openSettings, setOpenSettings] = useState(false);

  // Patient Info (single-line) Y coordinate (real PDF pixels)
  const [yValue, setYValue] = useState(200);

  // Doctor Info box (real PDF pixels)
  const [doctorInfo, setDoctorInfo] = useState("yes");
  const [doctorX, setDoctorX] = useState(20);
  const [doctorY, setDoctorY] = useState(20);

  // Doctor Note box (real PDF pixels)
  const [doctorNote, setDoctorNote] = useState("yes");
  const [appNote, setAppNote] = useState("yes");
  const [noteX, setNoteX] = useState(172);
  const [noteY, setNoteY] = useState(744);

  const [patientInfoLeftX, setPatientInfoLeftX] = useState(170);
  const [patientInfoLeftY, setPatientInfoLeftY] = useState(147);

  const [patientInfoRightX, setPatientInfoRightX] = useState(400);
  const [patientInfoRightY, setPatientInfoRightY] = useState(147);

  const handleOpenSettings = () => setOpenSettings(true);
  const handleCloseSettings = () => setOpenSettings(false);

  const handleReload = () => {
    fetchAllDoctors();
  };

  const handleEdit = (doctor) => {
    setSelectedDoctor(doctor);
    setIsDrawerOpen(true);
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
    setPage(0);
  };

  // const filteredDoctors = doctors.filter((doctor) => {
  //   return Object.values(doctor).some((value) =>
  //     String(value).toLowerCase().includes(searchQuery)
  //   );
  // });

  const formatToINR = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
    }).format(amount);
  };

  // const paginatedDoctors = filteredDoctors.slice(
  //   page * rowsPerPage,
  //   page * rowsPerPage + rowsPerPage
  // );

  const handleDelete = async (id) => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/doctor-delete/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      if (data.success) {
        alert(data.message); // Show success message to the user
        setDoctors(doctors.filter((doc) => doc._id !== id));
      } else {
        alert(`Error: ${data.message}`); // Show error message to the user
      }
    } catch (error) {
      alert("An unexpected error occurred while deleting the doctor.");
    }
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedDoctor(null);
  };

  const handleSignFileChange = async (e) => {
    const file = e.target.files[0];
    const result = await validateFile(file, FILE_RULES.signature);
    if (!result.valid) { alert(result.error); e.target.value = ""; return; }
    setSelectedDoctor({
      ...selectedDoctor,
      signFile: file,
    });
  };

  const handleSubmitEdit1 = async () => {
    try {
      const formData = new FormData();
      for (const key in selectedDoctor) {
        if (Array.isArray(selectedDoctor[key])) {
          selectedDoctor[key].forEach((item, index) => {
            formData.append(`${key}[${index}]`, item);
          });
        } else {
          formData.append(key, selectedDoctor[key]);
        }
      }
      const response = await fetch(
        `${BASE_URL}api/user/common/doctor-update/${selectedDoctor._id}`,
        {
          method: "PUT",
          headers: {
          },
          body: formData,
        },
      );
      const data = await response.json();
      if (data.success) {
        alert(data.message); // Show success message to the user
        const updatedPatients = doctors.map((doc) =>
          doc._id === selectedDoctor._id ? selectedDoctor : doc,
        );
        setDoctors(updatedPatients);
        handleCloseDrawer();
      } else {
        alert(`Error: ${data.message}`); // Show error message to the user
      }
    } catch (error) {
      alert("An unexpected error occurred while updating the patient.");
    }
  };
  const handleSubmitEdit = async () => {
    try {
      const formData = new FormData();

      for (const key in selectedDoctor) {
        if (key === "signFile") continue;

        if (Array.isArray(selectedDoctor[key])) {
          selectedDoctor[key].forEach((item, index) =>
            formData.append(`${key}[${index}]`, item),
          );
        } else {
          formData.append(key, selectedDoctor[key]);
        }
      }

      // If user uploaded new signature
      if (selectedDoctor.signFile) {
        formData.append("signFile", selectedDoctor.signFile);
      }
      formData.delete("appointmentTemplate");
      const response = await fetch(
        `${BASE_URL}api/user/common/doctor-update/${selectedDoctor._id}`,
        {
          method: "PUT",
          headers: {
          },
          body: formData,
        },
      );

      const data = await response.json();

      if (data.success) {
        toast.success(data.message);

        // update UI locally
        const updatedList = doctors.map((doc) =>
          doc._id === selectedDoctor._id ? selectedDoctor : doc,
        );
        setDoctors(updatedList);
        handleCloseDrawer();
      } else {
        toast.error("Error: " + data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Unexpected error while updating doctor.");
    }
  };

  const handleQualificationChange = (index, value) => {
    const updatedQualifications = [...selectedDoctor.qualifications];
    updatedQualifications[index] = value;
    setSelectedDoctor({
      ...selectedDoctor,
      qualifications: updatedQualifications,
    });
  };
  const addQualification = () => {
    setSelectedDoctor({
      ...selectedDoctor,
      qualifications: [...selectedDoctor.qualifications, ""],
    });
  };
  const removeQualification = (index) => {
    const updatedQualifications = selectedDoctor.qualifications.filter(
      (_, i) => i !== index,
    );
    setSelectedDoctor({
      ...selectedDoctor,
      qualifications: updatedQualifications,
    });
  };

  const [openLogDialog, setOpenLogDialog] = useState(false);
  const [doctorLogs, setDoctorLogs] = useState(null);
  const handleViewLog = async (doctorId) => {
    setOpenLogDialog(true);
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-logs?id=${doctorId}&targetType=${TARGET_TYPE.doctor}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const doctors = await response.json();
      setDoctorLogs(doctors.logs);
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      // setLoading(false);
    }
  };
  const handleCloseLog = () => {
    setOpenLogDialog(false);
  };

  const [excelLoading, setExcelLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const handleDownload = async () => {
    try {
      setExcelLoading(true);
      const response = await fetch(
        `${BASE_URL}api/user/common/export-excel-doctor`,
        {
          method: "GET",
          headers: {
          },
        },
      );

      if (!response.ok) throw new Error("Download failed");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "doctors.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setExcelLoading(false);
    }
  };

  const handleDownloadPdf = async () => {
    try {
      setPdfLoading(true);
      const response = await fetch(
        `${BASE_URL}api/user/common/export-pdf-doctor`,
        {
          method: "GET",
          headers: {
          },
        },
      );

      if (!response.ok) throw new Error("Download failed");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "doctors.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading PDF:", error);
    } finally {
      setPdfLoading(false);
    }
  };

  const [pdfTemplate, setPdfTemplate] = useState("");
  const fetchPdfTemplate = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-pdfTemplate-appoint`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      setPdfTemplate(data.pdf.docAppointPdfUrl);
    } catch (error) {}
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);

  const [doctors, setDoctors] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loadingDoctors, setLoadingDoctors] = useState(false);
  const [doctorSearchInput, setDoctorSearchInput] = useState("");

  // ✅ Local cache for pagination and search
  const [cache, setCache] = useState({});

  const fetchAllDoctors = async (page = 0, limit = 10, query = "") => {
    setLoadingDoctors(true);

    try {
      // ✅ Use search API if query exists
      const endpoint = query
        ? `${BASE_URL}api/user/common/doctors/search?query=${encodeURIComponent(
            query,
          )}&page=${page}&limit=${limit}`
        : `${BASE_URL}api/user/common/get-all-doctor?page=${page}&limit=${limit}`;

      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (result.success) {
        // ✅ Cache key (includes query)
        const cacheKey = `${query}_${page}_${limit}`;

        // ✅ Update cache
        setCache((prev) => ({
          ...prev,
          [cacheKey]: { data: result.data, totalCount: result.totalCount },
        }));

        setDoctors(result.data);
        setTotalCount(result.totalCount || result.data.length);
      } else {
        console.error("API failed:", result.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      setLoadingDoctors(false);
    }
  };

  // ✅ Fetch or load from cache whenever page, limit, or search changes
  useEffect(() => {
    fetchPdfTemplate();
    const cacheKey = `${doctorSearchInput}_${page}_${rowsPerPage}`;
    if (cache[cacheKey]) {
      // ✅ Load from cache
      setDoctors(cache[cacheKey].data);
      setTotalCount(cache[cacheKey].totalCount);
    } else {
      // ✅ Fetch fresh data
      fetchAllDoctors(page, rowsPerPage, doctorSearchInput);
    }
  }, [page, rowsPerPage, doctorSearchInput]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setRowsPerPage(newLimit);
    setPage(0);
    setCache({}); // clear cache since limit changed
  };

  // ✅ Debounce search input
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setPage(0); // reset to first page
      fetchAllDoctors(0, rowsPerPage, doctorSearchInput);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [doctorSearchInput]);
  return (
    <Box>
      {/* Pagination */}
      <TablePagination
        component="div"
        count={totalCount}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
      />
      <TableContainer
        component={Paper}
        elevation={3}
        sx={{
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 1,
          }}
        >
          <div>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                backgroundColor: "#f0fdf4", // tailwind: bg-green-50
                borderRadius: "5px",
                border: "1px solid #bbf7d0", // tailwind: border-green-200
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                maxHeight: 36,
                p: 1,
              }}
            >
              {totalCount}
              <Typography
                sx={{
                  color: "#166534", // tailwind: text-green-800
                  fontSize: "0.875rem", // text-sm
                  fontWeight: 500,
                }}
              >
                {"  " + "Doctors"}
              </Typography>
            </Box>

            <Tooltip title="Download Data" arrow placement="top">
              <IconButton onClick={handleClick}>
                <GetAppIcon color="primary" />
              </IconButton>
            </Tooltip>

            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              PaperProps={{
                sx: {
                  p: 1,
                  // width: 180,
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: -8,
                    left: 16,
                    width: 0,
                    height: 0,
                    borderLeft: "8px solid transparent",
                    borderRight: "8px solid transparent",
                    borderBottom: "8px solid white",
                  },
                },
              }}
            >
              <Box display="flex" gap={1}>
                {excelLoading ? (
                  <CircularProgress size={30} />
                ) : (
                  <Tooltip title="Excel" placement="bottom">
                    <img
                      onClick={handleDownload}
                      src={excelIcon}
                      style={{
                        height: "30px",
                        width: "30px",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                )}
                {pdfLoading ? (
                  <CircularProgress size={30} />
                ) : (
                  <Tooltip title="PDF" placement="bottom">
                    <img
                      onClick={handleDownloadPdf}
                      src={pdfIcon}
                      style={{
                        height: "30px",
                        width: "30px",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                )}
              </Box>
            </Popover>
          </div>
          <TextField
            placeholder="Search Doctors"
            variant="outlined"
            size="small"
            value={doctorSearchInput}
            onChange={(e) => setDoctorSearchInput(e.target.value)}
            sx={{ width: "20%", ml: "auto" }}
          />
          <button
            onClick={handleReload}
            style={{
              display: "flex",
              alignItems: "center",
              border: "none",
              background: "none",
              cursor: "pointer",
              padding: "8px",
            }}
          >
            <RefreshIcon style={{ color: "#1976d2", fontSize: "24px" }} />
          </button>
        </Box>
        <Table
          sx={{
            borderCollapse: "separate",
            borderSpacing: 0,
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
          }}
        >
          <TableHead
            sx={{
              backgroundColor: "#f3f4f6",
              "& .MuiTableCell-head": {
                fontWeight: 700,
                fontSize: "13px",
                color: "#374151",
                textTransform: "uppercase",
                letterSpacing: 0.5,
                padding: "12px",
                borderBottom: "1px solid #e5e7eb",
              },
            }}
          >
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Qualifications</TableCell>
              <TableCell>Consult Fees</TableCell>
              <TableCell>Note</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          {loadingDoctors && (
            <TableRow>
              <TableCell colSpan={8} sx={{ padding: 0 }}>
                <LinearProgress
                  color="success"
                  sx={{ height: 2, width: "100%" }}
                />
              </TableCell>
            </TableRow>
          )}

          <TableBody>
            {doctors.map((doctor) => (
              <TableRow
                key={doctor._id}
                sx={{
                  position: "relative",
                  "&:hover": {
                    backgroundColor: "#f9fafb",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
                  },
                  "& .doctorName": {
                    fontWeight: 500,
                    transition: "transform 0.2s ease",
                  },
                  "&:hover .doctorName": {
                    transform: "translateY(-2px)",
                  },
                  "&:hover .viewLogBtn": {
                    opacity: 1,
                    visibility: "visible",
                  },
                }}
              >
                <TableCell>
                  <Box className="doctorName">{doctor.name}</Box>
                  {user?._doc?.role === "Admin" && (
                    <Typography
                      className="viewLogBtn"
                      color="warning"
                      onClick={() => handleViewLog(doctor._id)}
                      sx={{
                        fontSize: "0.75rem",
                        cursor: "pointer",
                        position: "absolute",
                        top: "54%",
                        left: "15px",
                        mt: "2px",
                        opacity: 0,
                        visibility: "hidden",
                        transition: "opacity 0.2s ease, visibility 0.2s ease",
                      }}
                    >
                      <FormatAlignLeftIcon sx={{ fontSize: "1rem" }} />
                      view logs
                    </Typography>
                  )}
                </TableCell>
                <TableCell>
                  {doctor.qualifications[0]}
                  {doctor.qualifications.length > 1 && (
                    <Tooltip
                      title={
                        <div>
                          {doctor.qualifications.slice(1).map((qual, index) => (
                            <div key={index}>{qual}</div>
                          ))}
                        </div>
                      }
                      arrow
                      placement="top"
                    >
                      <Button
                        size="small"
                        variant="text"
                        sx={{
                          ml: 1,
                          textTransform: "none",
                          fontSize: "12px",
                          color: "#1976d2",
                        }}
                      >
                        +{doctor.qualifications.length - 1} more
                      </Button>
                    </Tooltip>
                  )}
                </TableCell>
                {/* <TableCell>{doctor.experience} Years</TableCell> */}
                <TableCell>{formatToINR(doctor.consultFees)}</TableCell>
                <TableCell>{doctor.note}</TableCell>
                <TableCell align="center">
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 1,
                    }}
                  >
                    {user?._doc?.permissions?.doctorManagement?.edit && (
                      <IconButton
                        color="primary"
                        onClick={() => handleEdit(doctor)}
                        size="small"
                      >
                        <EditIcon />
                      </IconButton>
                    )}
                    {!doctor.inUse &&
                      user?._doc?.permissions?.doctorManagement?.delete && (
                        <IconButton
                          color="error"
                          onClick={() => handleDelete(doctor._id)}
                          size="small"
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={handleCloseDrawer}
        PaperProps={{
          sx: {
            width: "70vw",
            height: "70vh",
            padding: 2,
            marginTop: "150px",
            borderTopLeftRadius: "20px",
            borderBottomLeftRadius: "20px",
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          gap={2}
          height="100%"
          justifyContent="space-between"
        >
          <div>
            <Typography variant="h4" sx={{ mb: 5 }}>
              Edit Doctor
            </Typography>
            {selectedDoctor && (
              <>
                <Grid container spacing={2}>
                  {/* Row 1: Doctor Name */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Doctor Name"
                      variant="outlined"
                      size="small"
                      name="name"
                      onChange={(e) =>
                        setSelectedDoctor({
                          ...selectedDoctor,
                          name: e.target.value,
                        })
                      }
                      value={selectedDoctor.name}
                    />
                  </Grid>

                  {/* Row 3: Registration ID, Experience */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Registration ID"
                      variant="outlined"
                      size="small"
                      name="regId"
                      onChange={(e) =>
                        setSelectedDoctor({
                          ...selectedDoctor,
                          regId: e.target.value,
                        })
                      }
                      value={selectedDoctor.regId}
                    />
                  </Grid>

                  {/* Row 4: OPD Hours, Consultation Fees */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Note"
                      variant="outlined"
                      size="small"
                      name="note"
                      onChange={(e) =>
                        setSelectedDoctor({
                          ...selectedDoctor,
                          note: e.target.value,
                        })
                      }
                      value={selectedDoctor.note}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Consultation Fees"
                      variant="outlined"
                      size="small"
                      type="number"
                      name="consultFees"
                      onChange={(e) =>
                        setSelectedDoctor({
                          ...selectedDoctor,
                          consultFees: e.target.value,
                        })
                      }
                      value={selectedDoctor.consultFees}
                    />
                  </Grid>

                  {/* Row 2: Qualifications */}
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        p: 3,
                        backgroundColor: "#ffffff",
                        borderRadius: "12px",
                        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                      }}
                    >
                      <Typography variant="subtitle1" gutterBottom>
                        Qualifications, Experiences etc.:
                      </Typography>
                      <Grid container spacing={2}>
                        {selectedDoctor.qualifications.map(
                          (qualification, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              key={index}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                              }}
                            >
                              <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                value={qualification}
                                onChange={(e) =>
                                  handleQualificationChange(
                                    index,
                                    e.target.value,
                                  )
                                }
                                // error={!!errors.qualifications}
                              />
                              <IconButton
                                onClick={() => removeQualification(index)}
                                disabled={
                                  selectedDoctor.qualifications.length === 1
                                }
                                color="error"
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Grid>
                          ),
                        )}
                      </Grid>
                      <IconButton
                        onClick={addQualification}
                        disabled={selectedDoctor.qualifications.length >= 6} // Disable if 5 qualifications
                        sx={{
                          mt: 2,
                          backgroundColor:
                            selectedDoctor.qualifications.length >= 6
                              ? "gray"
                              : "green",
                          color: "white",
                          "&:hover": {
                            backgroundColor:
                              selectedDoctor.qualifications.length >= 6
                                ? "gray"
                                : "darkgreen",
                          },
                        }}
                      >
                        <AddIcon />
                      </IconButton>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl variant="filled" fullWidth>
                      <InputLabel id="demo-simple-select-filled-label">
                        Is Consultant?
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={selectedDoctor.isConsultant}
                        name="isConsultant"
                        onChange={(e) =>
                          setSelectedDoctor({
                            ...selectedDoctor,
                            isConsultant: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl variant="filled" fullWidth>
                      <InputLabel id="demo-simple-select-filled-label">
                        Is Signatory?
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        name="isSignatory"
                        value={selectedDoctor.isSignatory}
                        onChange={(e) =>
                          setSelectedDoctor({
                            ...selectedDoctor,
                            isSignatory: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl variant="filled" fullWidth>
                      <InputLabel id="demo-simple-select-filled-label">
                        Signatory Category
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        name="signatoryCat"
                        value={selectedDoctor.signatoryCat}
                        onChange={(e) =>
                          setSelectedDoctor({
                            ...selectedDoctor,
                            signatoryCat: e.target.value,
                          })
                        }
                      >
                        {/* ["pathology", "radiology", "microbiology", "biochemistry"] */}
                        <MenuItem value="Pathology">Pathology</MenuItem>
                        <MenuItem value="Radiology">Radiology</MenuItem>
                        <MenuItem value="Microbiology">Microbiology</MenuItem>
                        <MenuItem value="Biochemistry">Biochemistry</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      id="filled-basic"
                      label="Sign Header"
                      variant="filled"
                      fullWidth
                      multiline
                      name="signHeader"
                      value={selectedDoctor.signHeader}
                      onChange={(e) =>
                        setSelectedDoctor({
                          ...selectedDoctor,
                          signHeader: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <FormControl variant="filled" fullWidth>
                      <Typography
                        sx={{
                          position: "absolute",
                          fontSize: "14px",
                          padding: "5px",
                        }}
                      >
                        Sign
                      </Typography>
                      <TextField
                        type="file"
                        fullWidth
                        variant="filled"
                        name="signwebLink"
                        onChange={handleSignFileChange}
                        inputProps={{ accept: "image/*" }}
                      />
                    </FormControl>
                  </Grid>
                  {selectedDoctor.isConsultant && (
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          mb: 2,
                          p: 2,
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          background: "#fafafa",
                        }}
                      >
                        <Typography sx={{ mb: 1, fontWeight: 600 }}>
                          Which appointment template do you want to use?
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            gap: 3,
                            alignItems: "center",
                          }}
                        >
                          <label
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                            }}
                          >
                            <input
                              type="radio"
                              name="whichAppointmentTemplate"
                              value="org"
                              checked={
                                selectedDoctor?.whichAppointmentTemplate ===
                                "org"
                              }
                              onChange={(e) =>
                                setSelectedDoctor((prev) => ({
                                  ...prev,
                                  whichAppointmentTemplate: "org",
                                }))
                              }
                            />
                            Organization Default Template
                          </label>

                          <label
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                            }}
                          >
                            <input
                              type="radio"
                              name="whichAppointmentTemplate"
                              value="doctor"
                              checked={
                                selectedDoctor?.whichAppointmentTemplate ===
                                "doctor"
                              }
                              onChange={(e) =>
                                setSelectedDoctor((prev) => ({
                                  ...prev,
                                  whichAppointmentTemplate: "doctor",
                                }))
                              }
                            />
                            Custom Doctor Template
                          </label>
                          {(selectedDoctor?.whichAppointmentTemplate ===
                            "doctor" ||
                            selectedDoctor?.whichAppointmentTemplate ===
                              "org") && (
                            <span>
                              <Button
                                variant="contained"
                                color="primary"
                                sx={{ textTransform: "none" }}
                                onClick={handleOpenSettings}
                              >
                                Template Settings
                              </Button>
                            </span>
                          )}
                        </Box>
                      </Box>
                    </Grid>
                  )}

                  <Grid item xs={12} sm={3}>
                    <Button
                      variant="contained"
                      color="warning"
                      sx={{ width: "100%", marginTop: 2, marginBottom: 2 }}
                      onClick={handleSubmitEdit}
                    >
                      Edit
                    </Button>
                  </Grid>
                </Grid>
              </>
            )}
          </div>
        </Box>
      </Drawer>
      <Dialog
        open={openSettings}
        onClose={handleCloseSettings}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>Appointment PDF Settings</DialogTitle>
        <DialogContent dividers>
          <PdfLayoutGuide
            yValue={yValue}
            patientInfoLeftX={patientInfoLeftX}
            setPatientInfoLeftX={setPatientInfoLeftX}
            patientInfoLeftY={patientInfoLeftY}
            setPatientInfoLeftY={setPatientInfoLeftY}
            patientInfoRightX={patientInfoRightX}
            setPatientInfoRightX={setPatientInfoRightX}
            patientInfoRightY={patientInfoRightY}
            setPatientInfoRightY={setPatientInfoRightY}
            setYValue={setYValue}
            doctorInfo={doctorInfo}
            setDoctorInfo={setDoctorInfo}
            doctorX={doctorX}
            setDoctorX={setDoctorX}
            doctorY={doctorY}
            setDoctorY={setDoctorY}
            doctorNote={doctorNote}
            setDoctorNote={setDoctorNote}
            appNote={appNote}
            setAppNote={setAppNote}
            noteX={noteX}
            setNoteX={setNoteX}
            noteY={noteY}
            setNoteY={setNoteY}
            selectedDoctor={selectedDoctor}
            setSelectedDoctor={setSelectedDoctor}
            doctors={doctors}
            setDoctors={setDoctors}
            handleCloseSettings={handleCloseSettings}
            orgPDF={pdfTemplate}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSettings}>Close</Button>
        </DialogActions>
      </Dialog>

      <Log
        openLogDialog={openLogDialog}
        handleCloseLog={handleCloseLog}
        logs={doctorLogs}
      />
    </Box>
  );
};

export default DoctorList;
